export const jobsMock = {
	"actualTotal": 19121,
	"facetList": [
		{
			"displayName": "Category",
			"name": "category",
			"values": [
				{
					"displayValue": "Full-time",
					"count": 9668,
					"selected": false,
					"value": "full+time"
				},
				{
					"displayValue": "Part-time",
					"count": 8465,
					"selected": false,
					"value": "part+time"
				},
				{
					"displayValue": "Seasonal",
					"count": 134,
					"selected": false,
					"value": "seasonal"
				},
				{
					"displayValue": "Summer",
					"count": 18,
					"selected": false,
					"value": "summer"
				},
				{
					"displayValue": "Teen",
					"count": 541,
					"selected": false,
					"value": "teen"
				}
			]
		},
		{
			"displayName": "Job Title",
			"name": "jobtitle",
			"values": [
				{
					"displayValue": "107308",
					"count": 1,
					"selected": false,
					"value": "107308"
				},
				{
					"displayValue": "123easdas",
					"count": 1,
					"selected": false,
					"value": "123easdas"
				},
				{
					"displayValue": "123rfsdfsd",
					"count": 1,
					"selected": false,
					"value": "123rfsdfsd"
				},
				{
					"displayValue": "123rwedfsdf",
					"count": 1,
					"selected": false,
					"value": "123rwedfsdf"
				},
				{
					"displayValue": "12easd asdas",
					"count": 1,
					"selected": false,
					"value": "12easd+asdas"
				},
				{
					"displayValue": "13rsdfsdf",
					"count": 3,
					"selected": false,
					"value": "13rsdfsdf"
				},
				{
					"displayValue": "13sdfsd",
					"count": 1,
					"selected": false,
					"value": "13sdfsd"
				},
				{
					"displayValue": "1raadsasdasd",
					"count": 1,
					"selected": false,
					"value": "1raadsasdasd"
				},
				{
					"displayValue": "1st and 2nd shift Manufacturing Openings (Machining & Loading)",
					"count": 1,
					"selected": false,
					"value": "1st+and+2nd+shift+manufacturing+openings+machining+loading"
				},
				{
					"displayValue": "1st shift Brake Press / Shear Operator",
					"count": 1,
					"selected": false,
					"value": "1st+shift+brake+press+shear+operator"
				},
				{
					"displayValue": "1st Shift Machine Operator",
					"count": 1,
					"selected": false,
					"value": "1st+shift+machine+operator"
				},
				{
					"displayValue": "1st Shift Machine Operator - Sioux Falls",
					"count": 1,
					"selected": false,
					"value": "1st+shift+machine+operator+-+sioux+falls"
				},
				{
					"displayValue": "1st shift Mechanic",
					"count": 1,
					"selected": false,
					"value": "1st+shift+mechanic"
				},
				{
					"displayValue": "1st Shift Medical Assembly",
					"count": 1,
					"selected": false,
					"value": "1st+shift+medical+assembly"
				},
				{
					"displayValue": "1st Shift MIG welder",
					"count": 1,
					"selected": false,
					"value": "1st+shift+mig+welder"
				},
				{
					"displayValue": "1st Shift Nurse",
					"count": 1,
					"selected": false,
					"value": "1st+shift+nurse"
				},
				{
					"displayValue": "1st shift Production Painter",
					"count": 1,
					"selected": false,
					"value": "1st+shift+production+painter"
				},
				{
					"displayValue": "1zsdasdasds",
					"count": 1,
					"selected": false,
					"value": "1zsdasdasds"
				},
				{
					"displayValue": "2-15 Licensed Insurance Agent",
					"count": 2,
					"selected": false,
					"value": "2-15+licensed+insurance+agent"
				},
				{
					"displayValue": "23 rasdas",
					"count": 1,
					"selected": false,
					"value": "23+rasdas"
				},
				{
					"displayValue": "23fsdfsdf",
					"count": 1,
					"selected": false,
					"value": "23fsdfsdf"
				},
				{
					"displayValue": "23rfsdf",
					"count": 1,
					"selected": false,
					"value": "23rfsdf"
				},
				{
					"displayValue": "23rfsdfas",
					"count": 1,
					"selected": false,
					"value": "23rfsdfas"
				},
				{
					"displayValue": "23rfsefsdf",
					"count": 1,
					"selected": false,
					"value": "23rfsefsdf"
				},
				{
					"displayValue": "23rsdfse fsdf",
					"count": 1,
					"selected": false,
					"value": "23rsdfse+fsdf"
				},
				{
					"displayValue": "23rsfdfsdfs",
					"count": 1,
					"selected": false,
					"value": "23rsfdfsdfs"
				},
				{
					"displayValue": "23sdfsd",
					"count": 1,
					"selected": false,
					"value": "23sdfsd"
				},
				{
					"displayValue": "23sdfsdfsd",
					"count": 1,
					"selected": false,
					"value": "23sdfsdfsd"
				},
				{
					"displayValue": "23sfsdfsdf",
					"count": 1,
					"selected": false,
					"value": "23sfsdfsdf"
				},
				{
					"displayValue": "24 hour CAREGivers",
					"count": 4,
					"selected": false,
					"value": "24+hour+caregivers"
				},
				{
					"displayValue": "2asdasd",
					"count": 1,
					"selected": false,
					"value": "2asdasd"
				},
				{
					"displayValue": "2nd & 3rd Shift Material Handler",
					"count": 1,
					"selected": false,
					"value": "2nd+3rd+shift+material+handler"
				},
				{
					"displayValue": "2nd shift Electrician",
					"count": 1,
					"selected": false,
					"value": "2nd+shift+electrician"
				},
				{
					"displayValue": "2nd shift Entry level warehouse",
					"count": 1,
					"selected": false,
					"value": "2nd+shift+entry+level+warehouse"
				},
				{
					"displayValue": "2nd Shift Forklift Operator",
					"count": 1,
					"selected": false,
					"value": "2nd+shift+forklift+operator"
				},
				{
					"displayValue": "2nd Shift Machine Operator",
					"count": 1,
					"selected": false,
					"value": "2nd+shift+machine+operator"
				},
				{
					"displayValue": "2nd shift Maintenance Technician - DP",
					"count": 1,
					"selected": false,
					"value": "2nd+shift+maintenance+technician+-+dp"
				},
				{
					"displayValue": "2nd Shift Medical Assembly",
					"count": 1,
					"selected": false,
					"value": "2nd+shift+medical+assembly"
				},
				{
					"displayValue": "2nd Shift Production Supervisor",
					"count": 1,
					"selected": false,
					"value": "2nd+shift+production+supervisor"
				},
				{
					"displayValue": "2nd shift Warehouse Loader",
					"count": 1,
					"selected": false,
					"value": "2nd+shift+warehouse+loader"
				},
				{
					"displayValue": "312rsdfsd",
					"count": 1,
					"selected": false,
					"value": "312rsdfsd"
				},
				{
					"displayValue": "31efdsdafse",
					"count": 1,
					"selected": false,
					"value": "31efdsdafse"
				},
				{
					"displayValue": "323fsdasdasd",
					"count": 1,
					"selected": false,
					"value": "323fsdasdasd"
				},
				{
					"displayValue": "32fsdfsdf",
					"count": 1,
					"selected": false,
					"value": "32fsdfsdf"
				},
				{
					"displayValue": "32r4sfdas",
					"count": 1,
					"selected": false,
					"value": "32r4sfdas"
				},
				{
					"displayValue": "32rsdf",
					"count": 1,
					"selected": false,
					"value": "32rsdf"
				},
				{
					"displayValue": "32rsdfsdfsdf",
					"count": 1,
					"selected": false,
					"value": "32rsdfsdfsdf"
				},
				{
					"displayValue": "32sdfsdfsd",
					"count": 1,
					"selected": false,
					"value": "32sdfsdfsd"
				},
				{
					"displayValue": "3ffdgdfrgdf",
					"count": 1,
					"selected": false,
					"value": "3ffdgdfrgdf"
				},
				{
					"displayValue": "3fsdfsdfsd",
					"count": 1,
					"selected": false,
					"value": "3fsdfsdfsd"
				},
				{
					"displayValue": "3r dasdasdasd",
					"count": 1,
					"selected": false,
					"value": "3r+dasdasdasd"
				},
				{
					"displayValue": "3rd Shift - Storefront/Production",
					"count": 1,
					"selected": false,
					"value": "3rd+shift+-+storefront+production"
				},
				{
					"displayValue": "3rd Shift Mechanical Inspector",
					"count": 1,
					"selected": false,
					"value": "3rd+shift+mechanical+inspector"
				},
				{
					"displayValue": "3rd shift Tig Welder",
					"count": 1,
					"selected": false,
					"value": "3rd+shift+tig+welder"
				},
				{
					"displayValue": "3rfsdfsdf",
					"count": 1,
					"selected": false,
					"value": "3rfsdfsdf"
				},
				{
					"displayValue": "3rsadfsef",
					"count": 1,
					"selected": false,
					"value": "3rsadfsef"
				},
				{
					"displayValue": "3rsafsdfs",
					"count": 1,
					"selected": false,
					"value": "3rsafsdfs"
				},
				{
					"displayValue": "3sadasdas",
					"count": 1,
					"selected": false,
					"value": "3sadasdas"
				},
				{
					"displayValue": "3wrdasd",
					"count": 1,
					"selected": false,
					"value": "3wrdasd"
				},
				{
					"displayValue": "6am Warehouse! $11/hr! Weekly Pay!  Benefits!",
					"count": 1,
					"selected": false,
					"value": "6am+warehouse+11+hr+weekly+pay+benefits"
				},
				{
					"displayValue": "A Level Diesel Technician",
					"count": 1,
					"selected": false,
					"value": "a+level+diesel+technician"
				},
				{
					"displayValue": "A&P Mechanic",
					"count": 7,
					"selected": false,
					"value": "a+p+mechanic"
				},
				{
					"displayValue": "A/R",
					"count": 1,
					"selected": false,
					"value": "a+r"
				},
				{
					"displayValue": "A/R Specialist",
					"count": 2,
					"selected": false,
					"value": "a+r+specialist"
				},
				{
					"displayValue": "A Short Job",
					"count": 320,
					"selected": false,
					"value": "a+short+job"
				},
				{
					"displayValue": "Academic Advisor-Education Placement",
					"count": 1,
					"selected": false,
					"value": "academic+advisor-education+placement"
				},
				{
					"displayValue": "Account Manager",
					"count": 1,
					"selected": false,
					"value": "account+manager"
				},
				{
					"displayValue": "Account Receivable",
					"count": 1,
					"selected": false,
					"value": "account+receivable"
				},
				{
					"displayValue": "Account Receivable Associate",
					"count": 1,
					"selected": false,
					"value": "account+receivable+associate"
				},
				{
					"displayValue": "Account Receivable Clerk",
					"count": 1,
					"selected": false,
					"value": "account+receivable+clerk"
				},
				{
					"displayValue": "Account Representative",
					"count": 1,
					"selected": false,
					"value": "account+representative"
				},
				{
					"displayValue": "Account Resolution Specialist/Collecitons",
					"count": 1,
					"selected": false,
					"value": "account+resolution+specialist+collecitons"
				},
				{
					"displayValue": "Account Specialist",
					"count": 1,
					"selected": false,
					"value": "account+specialist"
				},
				{
					"displayValue": "Accountant",
					"count": 2,
					"selected": false,
					"value": "accountant"
				},
				{
					"displayValue": "Accountant II",
					"count": 1,
					"selected": false,
					"value": "accountant+ii"
				},
				{
					"displayValue": "Accountant III",
					"count": 1,
					"selected": false,
					"value": "accountant+iii"
				},
				{
					"displayValue": "Accounting/AP Clerk",
					"count": 1,
					"selected": false,
					"value": "accounting+ap+clerk"
				},
				{
					"displayValue": "Accounting Assistant",
					"count": 7,
					"selected": false,
					"value": "accounting+assistant"
				},
				{
					"displayValue": "Accounting Specialist",
					"count": 1,
					"selected": false,
					"value": "accounting+specialist"
				},
				{
					"displayValue": "Accounts Payable",
					"count": 3,
					"selected": false,
					"value": "accounts+payable"
				},
				{
					"displayValue": "Accounts Payable/Admin",
					"count": 1,
					"selected": false,
					"value": "accounts+payable+admin"
				},
				{
					"displayValue": "Accounts Payable Associate",
					"count": 1,
					"selected": false,
					"value": "accounts+payable+associate"
				},
				{
					"displayValue": "Accounts Payable Clerk",
					"count": 1,
					"selected": false,
					"value": "accounts+payable+clerk"
				},
				{
					"displayValue": "Accounts Payable Manager",
					"count": 1,
					"selected": false,
					"value": "accounts+payable+manager"
				},
				{
					"displayValue": "Accounts Payable Representative",
					"count": 1,
					"selected": false,
					"value": "accounts+payable+representative"
				},
				{
					"displayValue": "Accounts Receivable Associate",
					"count": 1,
					"selected": false,
					"value": "accounts+receivable+associate"
				},
				{
					"displayValue": "Accounts Receivable Billing Coordinator",
					"count": 2,
					"selected": false,
					"value": "accounts+receivable+billing+coordinator"
				},
				{
					"displayValue": "Accounts Receivable Coordinator",
					"count": 3,
					"selected": false,
					"value": "accounts+receivable+coordinator"
				},
				{
					"displayValue": "Accounts Receivable Specialist",
					"count": 1,
					"selected": false,
					"value": "accounts+receivable+specialist"
				},
				{
					"displayValue": "ACI Tech",
					"count": 1,
					"selected": false,
					"value": "aci+tech"
				},
				{
					"displayValue": "Actors and Actresses",
					"count": 2,
					"selected": false,
					"value": "actors+and+actresses"
				},
				{
					"displayValue": "adfsdas",
					"count": 1,
					"selected": false,
					"value": "adfsdas"
				},
				{
					"displayValue": "Admin - Bond Underwriter Trainee",
					"count": 1,
					"selected": false,
					"value": "admin+-+bond+underwriter+trainee"
				},
				{
					"displayValue": "Admin Assistant",
					"count": 1,
					"selected": false,
					"value": "admin+assistant"
				},
				{
					"displayValue": "Admin Asst",
					"count": 1,
					"selected": false,
					"value": "admin+asst"
				},
				{
					"displayValue": "Admin/Bond Underwriter Trainee",
					"count": 1,
					"selected": false,
					"value": "admin+bond+underwriter+trainee"
				},
				{
					"displayValue": "Administrative Assisstant",
					"count": 1,
					"selected": false,
					"value": "administrative+assisstant"
				},
				{
					"displayValue": "Administrative Assistant",
					"count": 27,
					"selected": false,
					"value": "administrative+assistant"
				},
				{
					"displayValue": "Administrative Assistant - Supply Chain",
					"count": 1,
					"selected": false,
					"value": "administrative+assistant+-+supply+chain"
				},
				{
					"displayValue": "Administrative Assistant/ Dispatcher",
					"count": 1,
					"selected": false,
					"value": "administrative+assistant+dispatcher"
				}
			]
		}
	],
	"list": [
		{
			"addressLine1": "1899 Honeysuckle Lane",
			"addressLine2": null,
			"applicationURL": null,
			"brandTemplateId": 1000019,
			"categories": null,
			"city": "Portland",
			"company": "The Purple Cow",
			"county": "Multnomah",
			"id": "500001712",
			"industries": [
				"Other"
			],
			"jobTitle": "Spanish Job",
			"latitude": "45.5289",
			"longitude": "-122.6436",
			"postalCode": "97232",
			"stateProvCode": "OR"
		},
		{
			"addressLine1": "12edasd",
			"addressLine2": "Suite 202",
			"applicationURL": null,
			"brandTemplateId": 22627,
			"categories": [
				"Part-time",
				"Teen"
			],
			"city": "Glen Allen",
			"company": "My Company",
			"county": "Henrico",
			"id": "5914552",
			"industries": [
				"Administration & Office Support"
			],
			"jobTitle": "sdasdas",
			"latitude": "37.6839",
			"longitude": "-77.558",
			"postalCode": "23060",
			"stateProvCode": "VA"
		},
		{
			"addressLine1": "oisdvioeio",
			"addressLine2": "dioe",
			"applicationURL": null,
			"brandTemplateId": 22627,
			"categories": [
				"Full-time",
				"Part-time"
			],
			"city": "Midlothian",
			"company": "My Company",
			"county": "Chesterfield",
			"id": "5914585",
			"industries": [
				"Maintenance & Janitorial"
			],
			"jobTitle": "ChopperQueued",
			"latitude": "37.4373",
			"longitude": "-77.6622",
			"postalCode": "23112",
			"stateProvCode": "VA"
		},
		{
			"addressLine1": "Orlando, FL",
			"addressLine2": null,
			"applicationURL": null,
			"brandTemplateId": 18148,
			"categories": [
				"Full-time",
				"Part-time"
			],
			"city": "Orlando",
			"company": "Aerotek",
			"county": "Orange",
			"id": "5919006",
			"industries": [
				"Retail"
			],
			"jobTitle": "Portuguese- Accounting Clerk",
			"latitude": "28.5545",
			"longitude": "-81.3481",
			"postalCode": "32803",
			"stateProvCode": "FL"
		},
		{
			"addressLine1": "938 Shearwood Forest Drive",
			"addressLine2": null,
			"applicationURL": null,
			"brandTemplateId": 1000019,
			"categories": null,
			"city": "Merrimack",
			"company": "The Purple Cow",
			"county": "Hillsborough",
			"id": "500000942",
			"industries": [
				"Other"
			],
			"jobTitle": "Spanish Job",
			"latitude": "42.8551",
			"longitude": "-71.5193",
			"postalCode": "03054",
			"stateProvCode": "NH"
		},
		{
			"addressLine1": "New Company-23146",
			"addressLine2": null,
			"applicationURL": null,
			"brandTemplateId": 22907,
			"categories": [
				"Full-time"
			],
			"city": "Rockville",
			"company": "New Company",
			"county": "Hanover",
			"id": "5915308",
			"industries": [
				"Food & Restaurant"
			],
			"jobTitle": "Front of House - Manager",
			"latitude": "37.7327",
			"longitude": "-77.7096",
			"postalCode": "23146",
			"stateProvCode": "VA"
		},
		{
			"addressLine1": "3259 Lonely Oak Drive",
			"addressLine2": null,
			"applicationURL": null,
			"brandTemplateId": 1000026,
			"categories": null,
			"city": "Mobile",
			"company": "The Purple Cow",
			"county": "Mobile",
			"id": "500007145",
			"industries": [
				"Other"
			],
			"jobTitle": "Average Job",
			"latitude": "30.6903",
			"longitude": "-88.0467",
			"postalCode": "36602",
			"stateProvCode": "AL"
		},
		{
			"addressLine1": "Glendale Heights, IL",
			"addressLine2": null,
			"applicationURL": null,
			"brandTemplateId": 18148,
			"categories": [
				"Full-time",
				"Part-time"
			],
			"city": "Glendale Heights",
			"company": "Aerotek",
			"county": "DuPage",
			"id": "5920518",
			"industries": [
				"Retail"
			],
			"jobTitle": "Project Engineer (Aerospace)",
			"latitude": "41.9203",
			"longitude": "-88.081",
			"postalCode": "60139",
			"stateProvCode": "IL"
		},
		{
			"addressLine1": "Some Address",
			"addressLine2": null,
			"applicationURL": null,
			"brandTemplateId": 1000019,
			"categories": null,
			"city": "Summerville",
			"company": "The Purple Cow",
			"county": "Dorchester",
			"id": "500001291",
			"industries": [
				"Other"
			],
			"jobTitle": "Best Job Ever",
			"latitude": "33.0633",
			"longitude": "-80.1896",
			"postalCode": "29483",
			"stateProvCode": "SC"
		},
		{
			"addressLine1": "Swedesboro, NJ",
			"addressLine2": null,
			"applicationURL": null,
			"brandTemplateId": 18148,
			"categories": [
				"Full-time",
				"Part-time"
			],
			"city": "Swedesboro",
			"company": "Aerotek",
			"county": "Gloucester",
			"id": "5918070",
			"industries": [
				"Retail"
			],
			"jobTitle": "Welder",
			"latitude": "39.757",
			"longitude": "-75.3338",
			"postalCode": "08085",
			"stateProvCode": "NJ"
		}
	],
	"total": 1000,
	"startNum": 0,
	"endNum": 9,
	"numRequested": 10,
	"fromCache": false,
	"self": "/jobs/search",
	"elapsed": 43
}